function ActivityIndicator({ isActive, participant }) {
    return (
        <>
            {isActive && (
                <span className="Messages-typing" data-participant={participant}>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            )}
        </>
    );
}

export default ActivityIndicator;
